// Lightweight analytics/event logger for frontend -> backend
// Posts to /api/log_event with event_type and event_details

export async function logEvent(event_type, event_details = {}) {
  try {
    // Avoid noise in tests and SSR
    if (typeof window === 'undefined') return;
    if (process.env.NODE_ENV === 'test') return;

    const payload = {
      event_type,
      event_details: {
        ...event_details,
        // Common context
        path: window.location?.pathname,
        search: window.location?.search,
        title: document?.title,
        referrer: document?.referrer || null,
        userAgent: navigator?.userAgent,
        viewport: { w: window.innerWidth, h: window.innerHeight },
        ts: new Date().toISOString(),
      },
    };

    await fetch('/api/log_event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    }).catch(() => {}); // swallow network errors silently
  } catch (e) {
    // Never block UX due to analytics failure
  }
}
